/**
 * Shape generator: procedurally creates gaussian splats for basic shapes
 * (plane, disc, cube, sphere). Editor-agnostic - also usable from the CLI
 * (tools/generate-shape.ts) under node.
 */

import { PLY_LOAD_ROTATION, toPlyConvention } from './convention';
import { buildSplats, GaussianOptions } from './gaussian';
import { writePly } from './ply-writer';
import { estimateCount, sampleShape } from './sampling';
import { Distribution, SampleSet, ShapeKind, ShapeParams, SplatBuffers } from './types';

// generate raw splat attribute buffers for a shape, in editor world space
const generateShape = (params: ShapeParams, options: GaussianOptions = {}): SplatBuffers => {
    return buildSplats(sampleShape(params), params, options);
};

// generate a shape and serialize it to PLY bytes (INRIA file convention)
const generateShapePly = (params: ShapeParams, options: GaussianOptions = {}): Uint8Array => {
    return writePly(toPlyConvention(generateShape(params, options)));
};

export {
    generateShape,
    generateShapePly,
    estimateCount,
    sampleShape,
    buildSplats,
    writePly,
    toPlyConvention,
    PLY_LOAD_ROTATION,
    Distribution,
    GaussianOptions,
    SampleSet,
    ShapeKind,
    ShapeParams,
    SplatBuffers
};
